import {useMutation} from '@tanstack/react-query'
import {externalApiURL} from '@yandex-delivery/client-core/api/corp'
import type {ServerError} from '@yandex-delivery/core/utils/network'
import {addQuery} from '@yandex-delivery/utils'

import {fetch} from '../../../../../../api/fetch'
import {useConfigContext} from '../../../../../../contexts'
import type {AppConfig} from '../../../../../../types'
import type {LocationDetect, LocationDetectedVariant, LocationDetectResult} from '../../types'

export const DEFAULT_CITIES: LocationDetectedVariant[] = [
  {
    address: 'Россия, Москва',
    geo_id: 213,
  },
  {
    address: 'Россия, Санкт-Петербург',
    geo_id: 2,
  },
  {
    address: 'Россия, Свердловская область, Екатеринбург',
    geo_id: 54,
  },
  {
    address: 'Россия, Республика Татарстан, Казань',
    geo_id: 43,
  },
]

export function fetchDetectLocationDeprecated(
  body: LocationDetect,
  appConfig: AppConfig,
): Promise<LocationDetectedVariant[]> {
  return fetch<LocationDetect, LocationDetectResult, LocationDetectResult>(appConfig, {
    url: addQuery(externalApiURL('/platform/location/detect'), {country: appConfig.countryCode}),
    method: 'post',
    body,
  }).then(result => {
    if (result?.body.variants === undefined || result.body.variants.length === 0) {
      return DEFAULT_CITIES
    }

    return result.body.variants
  })
}

export function useFetchDetectLocation() {
  const appConfig = useConfigContext()

  const {
    mutate: fetchDetectLocationHandler,
    isPending,
    data: locations,
    error,
  } = useMutation<LocationDetectedVariant[], ServerError, string>({
    mutationKey: ['detect-location'],
    mutationFn: location => {
      return fetchDetectLocationDeprecated({location}, appConfig)
    },
  })

  return {
    isDetectLocation: isPending,
    locations,
    fetchDetectLocationHandler,
    error,
  }
}
